/**
 * **Ascott Limited**
 *
 * @exports partnership_374
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    const isAscottHomepage = window.location.hostname.match(/discoverasr|discover-asr-ia-uat/);
    const isAscottBookingEngine = window.location.pathname.includes('/booking/');
    /**
      * @memberOf module:partnership_374
      */
    partnership.getId = function getId() {
        return '374';
    };
    /**
      * @memberOf module:partnership_374
      */
    partnership.check = function check() {
        // Check if we are inside Ascott Limited BE
        return isAscottBookingEngine || isAscottHomepage;
    };
    /**
      * @memberOf module:partnership_374
      */
    partnership.getSiteId = function getSiteId() {
        const result = {};
        let storageHotelData;
        // We are using storageHotelData to prevent missing bookings
        // However, on the homepage, when moving from one hotel to another, the data of the previous hotel may be used,
        // so the partnership script is executed twice, once for the previous hotel and once for the current hotel, which can cause various issues.
        // Therefore, hotel ID data from storage should be restricted to be usable only in the case of booking engine pages.
        if (isAscottBookingEngine) {
            try {
                storageHotelData = JSON.parse(window.sessionStorage.getItem('transactionData') || window.localStorage.getItem('bookingSearchData'));
            }
            catch (err) {
                thn.logger.debug(err);
            }
        }
        const hotelId = thn.dataLayerHelper.get('HotelID') || thn.parseUrlParameter('hotel') || thn.parseUrlParameter('hotelCode') || storageHotelData?.hotelCode || '';
        const corpoPage = !!(document.querySelector('.opening') || !hotelId);
        if (corpoPage) {
            result.accountKey = '1FA038C452E2E7537A0CDFF4724F035C';
            return result;
        }
        result.externalId = hotelId;
        return result;
    };
    return partnership;
}

export { factory };
